import { useEffect, useRef } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { DifficultRoute } from 'entities/ticket/models/find-ticket/models'

import { ICalendarPriceResponse } from 'shared/api/Calendar'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'
import { priceShow } from 'shared/lib/priceShow'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import { useDialogBottomSheet } from '../../shared/ui/dialog-bottom-sheet/lib'

import { PriceTimelinePopup } from './components/price-timeline-popup'
import s from './styles.module.scss'

const WIDTH_BLOCK = 68

interface Props {
  price: ICalendarPriceResponse[] | undefined
  getListResultsByTimeline: (startDate: string, endDate: string) => void
  firstSegment: DifficultRoute
}
export const PriceTimeline = ({
  price,
  getListResultsByTimeline,
  firstSegment,
}: Props) => {
  const { openDialog } = useDialogBottomSheet()

  const swiperRef = useRef<HTMLDivElement>(null)

  const showDialog = () => {
    openDialog({
      child: <PriceTimelinePopup />,
    })
  }

  const { t } = useTranslation()

  const getCurrentDateIndex = () => {
    const idx = price?.findIndex((item) => item.dep_date === firstSegment.date)

    if (swiperRef.current && idx && idx > 0) {
      swiperRef.current.scrollTo({
        top: 0,
        left: idx * WIDTH_BLOCK,
      })
    }
  }

  useEffect(() => {
    if (price?.length) {
      getCurrentDateIndex()
    }
  }, [price?.length])

  const hasBackDate = price?.find((item) => item.back_date)
  return (
    <div className={s.timeline}>
      {hasBackDate ? (
        <div
          className={s.info}
          onClick={() => showDialog()}
        >
          <AppIcon
            id={AllIcons.INFO_CALENDAR}
            className={s.icon}
            height={21}
            width={21}
          />
        </div>
      ) : null}

      <div
        className={clsx(s.swiper)}
        ref={swiperRef}
      >
        {price?.map((item, index) => (
          <div
            className={clsx(
              s.swiperCard,
              firstSegment.date === item.dep_date &&
                firstSegment.back_date === item.back_date &&
                s.swiperCardActive,
              hasBackDate && index === 0 && s.hasInfo,
            )}
            key={index}
            onClick={() =>
              getListResultsByTimeline(item.dep_date, item.back_date)
            }
          >
            {item.price ? (
              <h3 className={clsx(s.price, item.is_cheapest && s.lowPrice)}>
                {t('from_price', {
                  price: priceShow(String(item.price)),
                })}
              </h3>
            ) : (
              <h3 className={clsx(s.price, item.is_cheapest && s.lowPrice)}>
                <AppIcon
                  className={s.loop}
                  id={AllIcons.LOOP}
                  height={16}
                  width={16}
                />
              </h3>
            )}

            <p className={s.date}>
              {item.back_date
                ? `${dateFormat(item.dep_date || '', DATE_FORMAT_LIST.DAY) || 'date'} - ${
                    dateFormat(
                      item.back_date || '',
                      DATE_FORMAT_LIST.DATE_MONTH_SHORT,
                    ) || 'date'
                  }`
                : `${dateFormat(item?.dep_date || '', DATE_FORMAT_LIST.DATE_MONTH) || ''}`}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}
